<template>
  <v-tooltip location="bottom" interactive :aria-label="$t('moreInfoEpeatTooltip')">
    <template #activator="{ props }">
      <div v-bind="props" class="d-flex ga-1 align-center justify-center cursor-pointer">
        <v-icon size="large" color="epeat" :icon="mdiLeafCircle" />
        <span class="text-epeat">
          {{ level || $t('epeat') }}
        </span>
      </div>
    </template>
    <template #default>
      <div class="d-flex flex-column align-center">
        <sf-link href="https://epeat.net/">
          {{ $t('epeatTooltip.title') }}
        </sf-link>
        <span>{{ $t('epeatTooltip.description1') }}</span>
        <span>{{ $t('epeatTooltip.description2') }}</span>
        <span>{{ $t('epeatTooltip.description3') }}</span>
      </div>
    </template>
  </v-tooltip>
</template>

<script setup lang="ts">
import SfLink from '@/components/text/SfLink.vue'
import { mdiLeafCircle } from '@mdi/js'

defineProps({
  level: {
    type: String,
    default: ''
  }
})
</script>
